// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { DepositAttestation } from '@daml.js/utility-bridge-v0/lib/Utility/Bridge/V0/Attestation/Deposit/module';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useDepositAttestations: () => UseQueryResult<
  TemplateContract<DepositAttestation>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const offset = useLedgerEnd();
  const { bridgeOperator } = useParties();
  return useQuery({
    queryKey: ['queryDepositAttestations', bridgeOperator, offset, ledgerApi],
    queryFn: async () => {
      return ledgerApi.queryDepositAttestations(offset!, bridgeOperator);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useDepositAttestations;
